<script>
    export let fill = '#FFF'
</script>

<style>
    svg#schedule-navbar {
        position: absolute;
        top: 46px;
        width: 413px;
        left: 1px;
        height: 44.09px;
    }
</style>

<svg id="schedule-navbar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 414 44.09">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} class="cls-1" width="414" height="44.09" />
        </g>
    </g>
</svg>
